import React from "react";

import "./mobile-menu.css";

import Dashboardicon from "../../components/Icons/Dashboard-Icon/Dashboardicon";
import BillerIcon from "../../components/Icons/Biller-Icon/BillerIcon";
import HistoryIcon from "../../components/Icons/History-Icon/HistoryIcon";
import SpendanalyisIcon from "../../components/Icons/Spendanalyis-Icon/SpendanalyisIcon";
import { Link } from 'react-router-dom';
import HelpIcon from "../../components/Icons/Help-Icon/HelpIcon";

function MobileMenu() {
  return (
    <>
      <section className="mobile-nav">
        <nav className="mobile-menu">
          <Link to="/home" exact={`${true}`}>
            <span className="nav__link nav__link--active" >
              <Dashboardicon />
              <span className="nav__text">Home</span>
            </span>
          </Link>
          <Link to="/my-bills" exact={`${true}`}>
            <span className="nav__link" >
              <BillerIcon />
              <span className="nav__text" >My Bills</span>
            </span>
          </Link>
          <Link to="/biller-categories" exact={`${true}`}>
            <span className="nav__link">
              <BillerIcon />
              <span className="nav__text">Add Biller</span>
            </span>
          </Link>
          <Link to="/history?tab=1" exact={`${true}`}>
            <span className="nav__link">
              <HistoryIcon />
              <span className="nav__text">History</span>
            </span>
          </Link>
          <Link to="/reminders-lists" exact={`${true}`}>
            <span className="nav__link" >
              <BillerIcon />
              <span className="nav__text" >Reminders</span>
            </span>
          </Link>
          <Link to="/spend-analysis" exact={`${true}`}>
            <span className="nav__link">
              <SpendanalyisIcon />
              <span className="nav__text">Spend Analysis</span>
            </span>
          </Link>
          <Link to="/help" exact={`${true}`}>
            <span className="nav__link">
            <HelpIcon />
              <span className="nav__text">Help</span>
            </span>
          </Link>
        </nav>
      </section>
    </>
  );
}

export default MobileMenu;
